
import {
    defineComponent,
    ref
} from 'vue'
import CigoIconFont from "@/components/cigo-ui/unit/basic/cigo-icon-font.vue";
export default defineComponent({
    name: 'CigoPreviewImg',
    components: {
        CigoIconFont
    },
    props: {
        layerData: {
            type: Object,
            default: {}
        }
    },
    setup(props, ctx) {
        let currImgIndex = ref(0);

        const changeImg = (step: number) => {
            let index = currImgIndex.value + step;
            currImgIndex.value = index >= 0 ? index % props.layerData.imgList.length : props.layerData.imgList.length + index;
            console.log('currImgIndex:', currImgIndex.value);
        };

        const close = () => {
            ctx.emit('close');
        };

        return {
            currImgIndex,
            changeImg,
            close
        };
    }
})
